import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis,
} from 'recharts';
import PropTypes from 'prop-types';

const NWBarChart = ({
  data, containerWidth, containerHeight,
}) => {
  const customLabel = ({
    x, y, width, height, offset, value,
  }) => (
    <text
      x={x + width / 2}
      y={y - offset}
      width={width}
      height={height}
      fill="#757679"
      fontSize="12"
      className="recharts-text recharts-label"
      textAnchor="middle"
    >
      <tspan x={x + width / 2} dy="0em">{`${value}%`}</tspan>
    </text>
  );

  return (
    <ResponsiveContainer width={containerWidth} height={containerHeight}>
      <BarChart
        data={data}
        barGap={16}
        barSize={8}
        barCategoryGap={16}
        margin={{
          top: 5, right: 15, left: 5, bottom: 5,
        }}
      >
        <XAxis type="category" dataKey="name" />
        <YAxis hide />
        <Bar
          dataKey="value"
          fill="#3FADEC"
          label={customLabel}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

NWBarChart.propTypes = {
  // The source data which each element is an object.
  data: PropTypes.arrayOf(PropTypes.object),
  // The width of chart container.
  containerWidth: PropTypes.string,
  // The height of chart container.
  containerHeight: PropTypes.string,
};

NWBarChart.defaultProps = {
  data: [
    { name: 'Category 1', value: 10 },
    { name: 'Category 2', value: 20 },
    { name: 'Category 3', value: 30 },
  ],
  containerWidth: '100%',
  containerHeight: '100%',
};

export default NWBarChart;
